import type { IProduct, IProductVariant } from '~/modules/product';
import { create } from 'zustand';

interface ProductVariantStore {
  productVariants: IProductVariant[];
  getProductVariantsByProductId: (productId?: IProduct['id']) => IProductVariant[];
  setProductVariants: (variants: IProductVariant[]) => void;
  upsertProductVariants: (newVariants: IProductVariant[]) => void;
}

export const useProductVariantStore = create<ProductVariantStore>((set, get) => ({
  productVariants: [],

  setProductVariants: (variants) => set({ productVariants: variants }),

  getProductVariantsByProductId: (productId) =>
    productId ? get().productVariants.filter((variant) => variant.productId === productId) : [],

  upsertProductVariants: (newVariants) => {
    set((state) => {
      const variantMap = new Map(state.productVariants.map((variant) => [variant.id, variant]));

      newVariants.forEach((newVariant) => {
        variantMap.set(newVariant.id, { ...variantMap.get(newVariant.id), ...newVariant });
      });

      return { productVariants: Array.from(variantMap.values()) };
    });
  },
}));
